var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-width":`${_vm.size}px`,"max-height":"90vh","src":`${_vm.imageUrl}/${_vm.imageSize}px/${_vm.getImageToDisplay(_vm.imageName())}`,"contain":""},on:{"error":_vm.missingImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }